import { definePart } from '../core/effect';
import { rgba } from '../canvas/paint';

/**
 * **光の帯**（Issue #530）。フェイズの切り替え・召喚の柱・斬撃の下地。
 *
 * 横に伸びる帯で、**中心が明るく上下へ抜ける**。縦にしたいときは器で 90° 回す
 * （`tf.rotation`）—— 素材は止まった 1 枚の絵だけを描く。
 * 加算合成が既定（`glow` と同じ理由）。
 */
export default definePart({
  id: 'beam',
  label: '光の帯',
  blend: 'add',
  /*
   * **素の大きさ**（Issue #531）。`{ screen: [x, y] }` は**点**なのでアンカーから大きさが取れない ——
   * 名乗らないと層ごと飛ばされて「宣言したのに何も出ない」になる。
   * 舞台のピクセル基準（1920×1080）で、変えたいときは `tf.scale`（素の大きさと変換は別）。
   */
  size: { w: 1920, h: 300 },
  schema: {
    color: { type: 'color', label: '色' },
    core: { type: 'number', label: '芯の太さ', min: 0.01, max: 1, step: 0.01 },
    edge: { type: 'number', label: '端の抜け', min: 0, max: 0.5, step: 0.01 },
  },
  style: { color: '#ffffff', core: 0.22, edge: 0.18 },

  draw(ctx, { size, style }) {
    if (!(size.w > 0) || !(size.h > 0)) return;
    // 縦方向（芯 → 上下へ抜ける）
    const v = ctx.createLinearGradient(0, 0, 0, size.h);
    const core = Math.min(0.98, Math.max(0.02, style.core));
    v.addColorStop(0, rgba(style.color, 0));
    v.addColorStop(0.5 - core / 2, rgba(style.color, 0.85));
    v.addColorStop(0.5, rgba(style.color, 1));
    v.addColorStop(0.5 + core / 2, rgba(style.color, 0.85));
    v.addColorStop(1, rgba(style.color, 0));
    ctx.fillStyle = v;
    ctx.fillRect(0, 0, size.w, size.h);
    if (style.edge > 0) {
      // 左右の端を抜く（帯が画面の外で切れているように見せない）
      const h = ctx.createLinearGradient(0, 0, size.w, 0);
      h.addColorStop(0, rgba('#000000', 1));
      h.addColorStop(style.edge, rgba('#000000', 0));
      h.addColorStop(1 - style.edge, rgba('#000000', 0));
      h.addColorStop(1, rgba('#000000', 1));
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = h;
      ctx.fillRect(0, 0, size.w, size.h);
      ctx.globalCompositeOperation = 'source-over';
    }
  },
});
